export default {
currency_code: "ريال",

offers: "العروض",
manage_offers: "إدارة العروض",
add_offer: "إضافة عرض",
offer_id: "رقم العرض",
validity: "مدة العرض",
offer_type: "نوع العرض",
no_offers: "لا توجد عروض",
category_offer: "عرض فئة",
active: "نشط",
expired: "منتهي",
upcoming: "قادم",
starts_in: "يبدأ خلال",
ending_in: "ينتهي خلال",
min: "دقيقة",
edit: "تعديل",
"create_offer": "إنشاء عرض",
  "update_offer": "تحديث العرض",
  "category_offer": "عرض حسب الفئة",
  "product_offer": "عرض حسب المنتج",
  "category": "الفئة",
  "sub_category": "الفئة الفرعية",
  "select_category": "اختر فئة",
  "deactivate_offer": "إلغاء تنشيط هذا العرض",
  "products_selected": "المنتجات المختارة",
  "select_products": "اختر المنتجات",
  "discount_type": "نوع الخصم",
  "discount_percentage": "نسبة الخصم (%)",
  "flat_amount": "قيمة الخصم",
  "buy_qty": "كمية الشراء",
  "get_qty": "كمية مجانية",
  "free_delivery": "تفعيل التوصيل المجاني",
  "start_date": "تاريخ البداية",
  "end_date": "تاريخ النهاية",
  "start_time": "وقت البداية",
  "end_time": "وقت النهاية",
  "offer_title": "عنوان العرض",
  "description": "الوصف",
  "save_offer": "حفظ العرض",
  search_offer: "البحث عن عرض",
status: "الحالة",
all: "الكل",
inactive: "غير نشط",
today: "اليوم",
action: "الإجراء",
search: "بحث",
offers_found: "عرض موجود",
Type:"نوع العرض",
valid:"العرض صالح",
}